var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fbinp-chk",class:[
    {'fbinp-chk-checked': _vm.checked },
    {'fbinp-chk-radio': _vm.radio },
    {'fbinp-chk-designer': _vm.designer } ]},[(_vm.checked)?_c('div',{staticClass:"fbinp-chk-con"},[_c('div',{staticClass:"fbinp-chk-stem"}),_c('div',{staticClass:"fbinp-chk-kick"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }